import { render, staticRenderFns } from "./donation.vue?vue&type=template&id=648f21c2"
import script from "./donation.vue?vue&type=script&lang=js"
export * from "./donation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports